import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppFormsModule } from '../../../forms/forms.module';
import { MaterialModule } from '../../../material.module';
import { SharedModule } from '../../../shared/shared.module';
import { ProductSelectComponent } from './components/product-select/product-select.component';
import { PurchasePriceComponent } from './components/purchase-price/purchase-price.component';

@NgModule({
  declarations: [ProductSelectComponent, PurchasePriceComponent],
  imports: [AppFormsModule, CommonModule, FormsModule, ReactiveFormsModule, MaterialModule, SharedModule],
  exports: [ProductSelectComponent, PurchasePriceComponent],
})
export class SharedStockModule {}
